import { render, staticRenderFns } from "./tableAllCargosSimple.vue?vue&type=template&id=cfeafdf0&"
import script from "./tableAllCargosSimple.vue?vue&type=script&lang=js&"
export * from "./tableAllCargosSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports